import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { useXWingspanPayerId } from "../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { ModalRequirementHistory } from "../components/ModalRequirementHistory";
import { useRequirementHistoryResources } from "../hooks/useRequirementHistoryResources";

export const getRequirementHistoryWidget = (requirement: PayeeRequirement) => {
  return <Widget requirement={requirement} />;
};

const Widget: React.FC<{ requirement: PayeeRequirement }> = ({
  requirement
}) => {
  const modal = useWSModalCustom(ModalRequirementHistory);
  const scope = useRequirementHistoryResources(requirement);
  // The contractor-details requirement route reads the requirement itself from
  // the expanded payer's account (`getPayeeRequirement` with the same scope), so
  // its audit trail has to be read from that account too — otherwise the screen
  // shows one account's requirement above another account's history. Resolves to
  // undefined off that route, which is the caller's own account.
  const xWingspanAccount = useXWingspanPayerId();

  return (
    <ResourceHistory
      resources={scope}
      xWingspanAccount={xWingspanAccount}
      onViewAll={() => {
        modal.open({ requirement });
      }}
    />
  );
};
